<template>
<b-overlay
      :show="loading"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    >
  <b-card title="Couleurs">
    <b-button
        href='/colors/add'
        variant="primary"
      >
        + Ajouter une couleur
      </b-button>
   
      <div v-if="!displaySort">
        <br />
      </div>
   <b-button
     v-if="!displaySort"
       @click="displaySort=true"
      >
        Trier
      </b-button>
      <br /><br />
   <template v-if="displaySort">
    <b-button
       @click="saveOrderCurrent()"
      >
        Enregistrer
      </b-button>
      &nbsp;
      <b-button
      variant="danger"
       @click="displaySort=false"
      >
        Annuler
      </b-button>
      <br /><br />
     
    <draggable v-model="colors" item-key="order_display">
      <table v-for="color in colors" class="table table-sort">
        <tr>
          <td>{{ color.name }}</td>
        </tr>
   </table>
    </draggable>

   </template>
    <!-- table -->
    
    <vue-good-table 
      v-else
      :columns="columns"
      :rows="colors"
      :pagination-options="{
        enabled: true,
        perPage:pageLength
      }"
    >
      <template
        slot="table-row"
        slot-scope="props"
      >
        <span
          v-if="props.column.field === 'name'"
          class="text-nowrap"
        >
          <span class="text-nowrap">{{ props.row.name }}</span>
        </span>
       
        <!-- Column: Action -->
        <span v-else-if="props.column.field === 'price'">
          {{ props.formattedRow[props.column.field] }}€
        </span>
        <span v-else-if="props.column.field === 'action'">
          <span>
            <b-dropdown
              variant="link"
              toggle-class="text-decoration-none"
              no-caret
            >
              <template v-slot:button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="text-body align-middle mr-25"
                />
              </template>
              <b-dropdown-item  @click="$router.push({name:'editColor', params: { id: props.row.id }})">
                <feather-icon
                  icon="Edit2Icon"
                  class="mr-50"
                />
                <span>Modifier</span>
              </b-dropdown-item>
              <b-dropdown-item v-b-modal.modal-danger @click="selectedItem=props.row.id">
                <feather-icon
                  icon="TrashIcon"
                  class="mr-50"
                />
                <span>Supprimer</span>
              </b-dropdown-item>
            </b-dropdown>
          </span>
        </span>
        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>
      <template
        slot="pagination-bottom"
        slot-scope="props"
      >
        <div class="d-flex justify-content-between flex-wrap">
          <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap ">
              Page 1 de
            </span>
            <b-form-select
              v-model="pageLength"
              :options="['3','5','10','50']"
              class="mx-1"
              @input="(value)=>props.perPageChanged({currentPerPage:value})"
            />
            <span class="text-nowrap"> sur {{ props.total }} résultats </span>
          </div>
          <div>
            <b-pagination
              :value="1"
              :total-rows="totalRows"
              v-model="currentPage"
              :per-page="pageLength"
              first-number
              last-number
              align="right"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
              @input="(value)=>props.pageChanged({currentPage:value})"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>
          </div>
        </div>
        <b-modal
          id="modal-danger"
          cancel-variant="outline-secondary"
          cancel-title="Non"
          ok-variant="danger"
          ok-title="Oui"
          @ok="deleteColor(selectedItem)"
          modal-class="modal-danger"
          centered
          title="Êtes-vous sûr ?"
        >
          <b-card-text>
            Attention, cette action est irréversible ! Êtes-vous sûr de vouloir supprimer cette couleur ?
          </b-card-text>
        </b-modal>
      </template>
    </vue-good-table>
  
  </b-card>
</b-overlay>
</template>

<script>
import {BModal, BButton,BOverlay, VBModal, BCard, BCardText, BAvatar, BBadge, BPagination, BFormGroup, BFormInput, BFormSelect, BDropdown, BDropdownItem, } from 'bootstrap-vue'
import {APIRequest} from '@simb2s/senseye-sdk'
import { VueGoodTable } from 'vue-good-table'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import draggable from 'vuedraggable'

export default {
  components: {
    BCard,
    BCardText,
    draggable,
    VueGoodTable,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BModal,
    BOverlay,
    BButton
  },
  data() {
    return {
      colors:[],
      
      pageLength: 50,
      displaySort:false,
      totalRows:0,
      currentPage:1,
      dir: false,
      loading:true,
      selectedItem:null,
      columns: [
        {
          label: 'Nom',
          field: 'name',
        },
        {
          label: 'Prix',
          field: 'price',
        },
        {
          label: 'Action',
          field: 'action',
        }
        
      ],
      rows: [],
      searchTerm: '',

    }
  },
  watch:{
    currentPage:async function(){
      this.loading=true
      let offset=this.currentPage*this.pageLength
      let colors=await APIRequest.list('colors', null, null, this.pageLength,offset)
      this.colors=colors[0]
      this.loading=false
    }
  },
  methods:{
    async saveOrderCurrent() {
      this.loading=true

      for(let i=0;i<this.colors.length;i++)
      {
        let datas=this.colors[i]
       
        datas.order_display=i
        
        await APIRequest.update('colors',this.colors[i].id,datas)
      }
      this.loading=false
      this.displaySort=false
    },
    async onEndSort(){
      console.log('sort end')
      console.log(this.colors)
    },
    async deleteColor(id)
    {
      this.loading=true
      try {
        await APIRequest.delete('colors',id)
        let colors=await APIRequest.list('colors')
        this.colors=colors[0]
        this.totalRows=colors[1]
        this.loading=false
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'La couleur a été supprimée !',
            icon: 'CheckIcon',
            variant: 'success',
          },
        })
        
      } catch (error) {
        this.loading=false
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Une erreur est survenue.',
            icon: 'AlertCircleIcon',
            variant: 'warning',
          },
        })
        
      }
      
    }
  },
  async mounted()
  {
    let colors=await APIRequest.list('colors')
    this.colors=colors[0]
    this.totalRows=colors[1]
    this.loading=false
  }
}
</script>

<style lang="scss" >
@import '@core/scss/vue/libs/vue-good-table.scss';
.table-sort td
{
  width:100%;
text-align: center;
}
</style>
